import { cn } from "@omni/utils/styles";
import { useRef } from "react";

import { Spinner } from "@/components/General/Spinner/spinner.component";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { Preview } from "../preview/preview";

const Steps = () => {
    const {
        steps,
        currentStep,
        isLoadingProducts,
        selectedColor,
        isRestoringState
    } = usePaintConfiguratorContext();
    const currentIndex = currentStep?.index ?? 0;

    const prevIndexRef = useRef<number | null>(null);
    const isAnimating =
        prevIndexRef.current !== null && prevIndexRef.current !== currentIndex;
    const isGoingForward =
        prevIndexRef.current === null || currentIndex > prevIndexRef.current;
    prevIndexRef.current = currentIndex;

    const step = steps.at(currentIndex);
    if (!step) return null;
    const { component: StepComponent } = step;

    return (
        <div className={cn("tw:grid tw:grid-cols-4 tw:gap-4")}>
            <div
                className={cn(
                    "tw:col-span-4",
                    selectedColor ? "tw:md:col-span-3" : ""
                )}
            >
                <div className={cn("tw:relative tw:overflow-hidden tw:p-2")}>
                    <div
                        key={currentIndex}
                        className={cn("tw:duration-500", {
                            "tw:animate-slide-in-right":
                                isAnimating && isGoingForward,
                            "tw:animate-slide-in-left":
                                isAnimating && !isGoingForward
                        })}
                    >
                        {isLoadingProducts || isRestoringState ? (
                            <div
                                className={cn(
                                    "tw:h- tw:w-full tw:flex tw:items-center tw:justify-center tw:mt-10"
                                )}
                            >
                                <Spinner />
                            </div>
                        ) : (
                            <StepComponent />
                        )}
                    </div>
                </div>
            </div>
            <div
                className={cn(
                    "tw:hidden tw:md:block tw:col-span-1",
                    "tw:sticky tw:top-0 tw:pt-4 tw:bg-white tw:layer-base/[10]"
                )}
            >
                <Preview />
            </div>
        </div>
    );
};

export { Steps };
